import { render } from "./ColorRenderer.vue?vue&type=template&id=9a91474e&scoped=true"
import script from "./ColorRenderer.vue?vue&type=script&lang=js"
export * from "./ColorRenderer.vue?vue&type=script&lang=js"

import "./ColorRenderer.vue?vue&type=style&index=0&id=9a91474e&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a91474e"]])

export default __exports__